export const enum ViewType {
  LIST_VIEW = 'list',
  CARD_VIEW = 'card',
}

export const DEFAULT_PAGE_SIZE = 60;
